<template>
  <Card class="event-card-posts" @click="handleOpenEvent">
    <template #title>
      <div class="event-card-container-title">
        <span class="event-card-title-name" @click="handleOpenEvent" :title="event.title">
          {{ truncatedTitle(event.title) }}
        </span>
        <span class="event-card-title-date" @click="handleOpenEvent">
          {{ formatDate(event.date) }}
        </span>
      </div>
    </template>
    <template #content>
      <img
        v-if="event.image"
        :src="event.image"
        alt="Social Media Evento"
        class="event-body-image"
        @click="handleOpenEvent"
      />
      <div v-if="!event.image" class="event-body-no-image" @click="handleOpenEvent"></div>
    </template>
    <template #footer>
      <div class="event-card-footer-container-stats">
        <div class="event-card-footer-stats">
          <img
            src="/social-media-event-icon1.svg"
            alt="Social Media Evento"
            title="Total de comentários"
          />
          <span>{{ event.reviews }}</span>
        </div>
        <div class="event-card-footer-stats">
          <img
            src="/social-media-event-icon2.svg"
            alt="Social Media Evento"
            title="Total de avaliações"
          />
          <span>{{ event.rating }}</span>
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import Card from 'primevue/card'
import moment from 'moment'
moment.locale('pt-br')

export default {
  components: {
    Card,
  },
  props: {
    socialMediaType: String,
    event: Object,
  },
  methods: {
    truncatedTitle(title) {
      if (title.length > 30) {
        return title.substring(0, 30) + '...'
      }
      return title
    },
    handleOpenEvent() {
      window.open(this.event.link)
    },
    formatDate(date) {
      const year = new Date().getFullYear()
      const fullDate = `${date}/${year}`
      return moment(fullDate, 'MM/DD/YYYY').format('dddd, D [de] MMMM')
    },
  },
}
</script>

<style lang="scss" src="./styles.scss"></style>
